var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter, Output } from "@angular/core";
import { BaseComponent } from "../../../../common/components/base.component";
import { PlaceType } from "../../place.category/customize.place.category.component";
import { HubPlace } from "../../../../models/hub/hub.place";
import { PlaceService } from "../../../../services/place.service";
var PlaceCategorySelectorComponent = /** @class */ (function (_super) {
    __extends(PlaceCategorySelectorComponent, _super);
    function PlaceCategorySelectorComponent() {
        var _this = _super.call(this) || this;
        _this.isUseDefault = true;
        _this.clientPlaceCategories = [];
        _this.blockGooglePlaceCategories = [];
        _this.item = new PlaceType();
        return _this;
    }
    PlaceCategorySelectorComponent.prototype.isCreateNewPlace = function () {
        return !this.place || !this.place.categoryText;
    };
    PlaceCategorySelectorComponent.prototype.isSelected = function (categoryTitle) {
        if (this.isCreateNewPlace())
            return false;
        return this.place.categoryList.indexOf(categoryTitle) >= 0;
    };
    PlaceCategorySelectorComponent.prototype.selectionChange = function (category) {
        var categoryTitle = category.source.name;
        categoryTitle = PlaceService.toCategoryCode(categoryTitle);
        if (this.place.categoryList.indexOf(categoryTitle) >= 0) {
            this.place.categoryList = this.place.categoryList.filter(function (x) { return x !== categoryTitle; });
        }
        else {
            this.place.categoryList.push(categoryTitle);
        }
        this.place.category = this.place.categoryList.join(', ');
        var readable = this.place.categoryList.map(function (x) { return PlaceService.toReadableCategory(x); });
        this.place.categoryText = readable.join(', ');
    };
    PlaceCategorySelectorComponent.prototype.toReadable = function (code) {
        return PlaceService.toReadableCategory(code);
    };
    PlaceCategorySelectorComponent.prototype.toCode = function (category) {
        return PlaceService.toCategoryCode(category);
    };
    return PlaceCategorySelectorComponent;
}(BaseComponent));
export { PlaceCategorySelectorComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.category.modal/place.category.selector/place.category.selector.component.ts.pre-build-optimizer.js